import { io } from "socket.io-client";

const socket = io("https://dev-api.iwcsrvr.com"); // Replace with your server URL

export default socket;